import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import logo from "./img/logo_klein.png";
const supportsNotifications = () => {
   return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
};

export default function NotificationCheck({}) {
   const [notStatus, setNotStatus] = useState(() => {
      let notPermission = supportsNotifications() ? Notification.permission : "granted";
      return notPermission;
   });

   const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
         console.log("granted");

         showNotification();
         setNotStatus(permission);
      } else {
         setNotStatus(permission);
         console.log(permission);
      }
   };

   // 2. Notification anzeigen
   const showNotification = () => {
      const notification = new Notification("Benachrichtigungen aktiviert!", {
         body: "Benachrichtigungen wurden aktiviert.",
         icon: logo,
      });

      notification.onclick = () => {
         window.focus(); // Bringt den Tab in den Vordergrund
      };
   };
   if (false && (notStatus !== "granted")) {
      return (
         <div className="notification-check">
            <div>
               <h5>Bitte Benachrichtigungen aktivieren!</h5>
               <div>
                  Hier geht es zur{" "}
                  <a
                     target="_blank"
                     href="https://teams.microsoft.com/l/message/19:de2957c13b10493c8288298fe80ccbc3@thread.tacv2/1773660503648?tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93&groupId=a597b6ed-144a-496d-9e1f-dee799af880e&parentMessageId=1773660503648&teamName=Baur%20Immobilien%20e.K.&channelName=General&createdTime=1773660503648"
                  >
                     Anleitung
                  </a>
                  !
               </div>
               <div className="mt-2 text-end">
                  <Button
                     variant="warning"
                     onClick={() => {
                        requestPermission();
                     }}
                  >
                     Aktivieren
                  </Button>
               </div>
            </div>
         </div>
      );
   }
}
